module.exports = __webpack_public_path__ + "static/media/objective3.282b619c.svg";